const apiKey = Object.freeze({
  API_KEY: 'AIzaSyAkTdRqS1U739z_wbpg1yzQXs-W7uoNkYU',
  AUTH_DOMAIN: 'react-hacker-news-d7539.firebaseapp.com',
  DATABASE_URL: 'https://react-hacker-news-d7539.firebaseio.com',
  PROJECT_ID: 'react-hacker-news-d7539',
  STORAGE_BUCKET: 'react-hacker-news-d7539.appspot.com',
  MESSAGING_SENDER_ID: '845953118743',
  APP_ID: '1:845953118743:web:40810feb4fc93c9aeda252',
  MEASUREMENT_ID: 'G-GKT45TJ8L5'
});

export default apiKey;
